"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Guide = function Guide(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 5.5H8C7.93432 5.49993 7.86927 5.51282 7.80858 5.53792C7.74788 5.56302 7.69274 5.59985 7.64629 5.64629C7.59985 5.69274 7.56302 5.74788 7.53792 5.80858C7.51282 5.86927 7.49993 5.93432 7.5 6V18C7.5 18.1326 7.55268 18.2598 7.64645 18.3536C7.74021 18.4473 7.86739 18.5 8 18.5H16C16.0171 18.5 16.0341 18.4991 16.0511 18.4974C16.0669 18.4958 16.0824 18.4935 16.0977 18.4904C16.2112 18.4678 16.3132 18.4066 16.3866 18.3172C16.4599 18.2278 16.5 18.1157 16.5 18V6C16.5 5.86739 16.4473 5.74022 16.3536 5.64645C16.2598 5.55268 16.1326 5.5 16 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 12.5001C14.8689 12.5003 14.7431 12.4488 14.6497 12.3569L12.6157 10.3592C12.5211 10.2663 12.4673 10.1395 12.4661 10.0069C12.4649 9.87434 12.5165 9.74669 12.6094 9.65208C12.7023 9.55747 12.829 9.50365 12.9616 9.50246C13.0942 9.50127 13.2219 9.55281 13.3165 9.64573L15.3504 11.6434C15.4212 11.713 15.4697 11.8021 15.4898 11.8993C15.5098 11.9965 15.5004 12.0975 15.4628 12.1894C15.4253 12.2813 15.3612 12.3599 15.2787 12.4153C15.1963 12.4706 15.0993 12.5002 15 12.5001Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 12.5H9C8.86739 12.5 8.74021 12.4473 8.64645 12.3536C8.55268 12.2598 8.5 12.1326 8.5 12C8.5 11.8674 8.55268 11.7402 8.64645 11.6464C8.74021 11.5527 8.86739 11.5 9 11.5H14C14.1326 11.5 14.2598 11.5527 14.3536 11.6464C14.4473 11.7402 14.5 11.8674 14.5 12C14.5 12.1326 14.4473 12.2598 14.3536 12.3536C14.2598 12.4473 14.1326 12.5 14 12.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13 14.5C12.9011 14.5 12.8044 14.4707 12.7222 14.4157C12.64 14.3608 12.5759 14.2827 12.5381 14.1913C12.5002 14.1 12.4903 13.9994 12.5096 13.9025C12.5289 13.8055 12.5765 13.7164 12.6464 13.6464L14.6465 11.6464C14.7402 11.5527 14.8674 11.5 15 11.5C15.1326 11.5 15.2598 11.5527 15.3536 11.6464C15.4473 11.7402 15.5 11.8674 15.5 12C15.5 12.1326 15.4473 12.2598 15.3536 12.3536L13.3536 14.3536C13.3072 14.4001 13.2521 14.4369 13.1914 14.4621C13.1307 14.4872 13.0657 14.5001 13 14.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M24 12C24.0037 9.69426 23.3398 7.43675 22.0886 5.5H20C19.9343 5.49993 19.8693 5.51282 19.8086 5.53792C19.7479 5.56302 19.6927 5.59985 19.6463 5.64629C19.5998 5.69274 19.563 5.74788 19.5379 5.80858C19.5128 5.86927 19.4999 5.93432 19.5 6V18C19.5 18.1326 19.5527 18.2598 19.6464 18.3536C19.7402 18.4473 19.8674 18.5 20 18.5H22.0886C23.3398 16.5633 24.0037 14.3057 24 12Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M4 5.5H1.91136C0.663536 7.43829 0 9.69478 0 12C0 14.3052 0.663536 16.5617 1.91136 18.5H4C4.01707 18.5 4.03413 18.4991 4.05111 18.4974C4.06689 18.4958 4.08243 18.4935 4.09772 18.4904C4.21116 18.4678 4.31324 18.4066 4.38659 18.3172C4.45994 18.2278 4.50002 18.1157 4.5 18V6C4.5 5.86739 4.44732 5.74021 4.35356 5.64645C4.25979 5.55268 4.13261 5.5 4 5.5Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.foregroundColor
  }))));
};

Guide.defaultProps = {
  altText: "Guide",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Guide.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Guide;
exports.default = _default;